export default {
  brand: 'Sun Power',
  studio: 'الاستوديو',
  lottery: 'السحب المحظوظ',
  companyHome: 'الشركة',
  companyHomeNotConfigured: 'موقع الشركة غير مُعدّ',
  game: 'الألعاب',
  profile: 'حسابي',
  service: 'الدعم',
  serviceNotConfigured: 'رابط الدعم غير مُعدّ',
  language: 'اللغة',
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  inviteCode: 'UID',
  uid: 'UID',
  shareLink: 'رابط المشاركة',
  copyLink: 'نسخ الرابط',
  copied: 'تم النسخ',
  copyFail: 'فشل النسخ',
  recharge: 'شحن',
  withdraw: 'سحب',
  exchange: 'تحويل',
  balanceUsd: 'رصيد USD',
  balanceKwh: 'احتياطي kWh',
  checkin: 'تسجيل الحضور',
  upgrade: 'ترقية المستوى',
  team: 'فريقي',
  basic: 'أساسي',
  vip1: 'VIP1',
  vip2: 'VIP2',
  vip3: 'VIP3',
  activity: 'نشاط',
  unitPrice: 'سعر الوحدة',
  quantity: 'الكمية',
  minQtyTip: 'الحد الأدنى للطلب: {n}',
  expectKwh: 'الطاقة المتوقعة',
  totalAmount: 'المبلغ الإجمالي',
  progress: 'التقدم',
  buy: 'شراء',
  buyConfirm: 'تأكيد الشراء',
  confirmBuy: 'ادفع الآن',
  buyConfirmTip: 'سيتم خصم USD من رصيدك. لا يمكن التراجع.',
  buySuccess: 'تم الشراء بنجاح',
  productName: 'المنتج',
  amount: 'المبلغ',
  rechargeRate: 'سعر الصرف',
  rechargeActual: 'المبلغ المستلم',
  enterAmount: 'أدخل المبلغ',
  network: 'الشبكة',
  selectNetwork: 'اختر الشبكة',
  withdrawAddress: 'عنوان المحفظة',
  enterWithdrawAddress: 'أدخل عنوان المحفظة',
  txHash: 'هاش المعاملة',
  txHashOptional: 'اختياري بعد التحويل',
  copyAddress: 'نسخ العنوان',
  rechargeHint: 'أرسل USDT إلى العنوان أدناه؛ سيتم إضافة الرصيد بعد الإرسال بوقت قصير',
  withdrawHint: 'يُحجز الرصيد عند الإرسال؛ تُخصم الرسوم ثم يُحوَّل إلى محفظتك بعد الموافقة',
  withdrawFeeRate: 'نسبة الرسوم',
  withdrawFee: 'الرسوم',
  withdrawReceive: 'ستستلم',
  withdrawTooLow: 'المبلغ منخفض جداً بعد الرسوم',
  rechargeSubmitted: 'تم إرسال طلب الشحن',
  withdrawSubmitted: 'تم إرسال طلب السحب',
  noQr: 'لا يوجد رمز QR',
  noRechargeAddress: 'عنوان الإيداع غير مُعدّ',
  rechargeProof: 'إثبات الدفع',
  rechargeProofTip: 'يرجى رفع لقطة شاشة للتحويل الناجح',
  rechargeProofRequired: 'يرجى رفع إثبات الدفع',
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  kyc: 'التحقق من الهوية',
  realName: 'الاسم الحقيقي',
  idCard: 'رقم الهوية',
  contact: 'التواصل',
  contactPlaceholder: 'هاتف / واتساب / تيليجرام',
  contactRequired: 'التواصل مطلوب',
  idFront: 'وجه الهوية',
  idBack: 'ظهر الهوية',
  kycStatus: 'حالة التحقق',
  kycNone: 'غير موثّق',
  kycPending: 'قيد المعالجة',
  kycApproved: 'موثّق',
  kycRejected: 'مرفوض',
  kycTip: 'أدخل بياناتك وارفع وجهي بطاقة الهوية',
  kycRequired: 'الاسم ورقم الهوية مطلوبان',
  kycNeedPhotos: 'يرجى رفع صور الهوية',
  kycSubmitted: 'تم الإرسال، يرجى الانتظار',
  submit: 'إرسال',
  logout: 'تسجيل الخروج',
  appDownload: 'تحميل التطبيق',
  downloadPickTip: 'اختر نظام هاتفك ثم اتبع دليل التثبيت',
  downloadAndroidShort: 'حزمة APK (أندرويد)',
  downloadIosShort: 'ملف التهيئة (آيفون / آيباد)',
  downloadNow: 'تحميل الآن',
  downloadAndroidSteps: [
    'اضغط الزر أدناه لتحميل ملف APK',
    'افتح الملفات / التنزيلات، اعثر على حزمة Sun Power وافتحها',
    'إذا ظهر Google Play Protect بأن التطبيق محظور: اضغط «التثبيت على أي حال»',
    'إذا كان تثبيت المصادر غير المعروفة محظوراً: الإعدادات → التطبيقات → وصول خاص → تثبيت تطبيقات غير معروفة، واسمح للمتصفح أو مدير الملفات',
    'اتبع التعليمات على الشاشة لإكمال التثبيت ثم افتح Sun Power'
  ],
  downloadIosSteps: [
    'اضغط الزر أدناه؛ سيفتح Safari ملف التثبيت',
    'إذا ظهر «تم تنزيل الملف الشخصي»: افتح الإعدادات → الملف الشخصي الذي تم تنزيله (أو عام → VPN وإدارة الجهاز)',
    'اضغط تثبيت، أدخل رمز القفل، ثم أكّد',
    'بعد التثبيت، افتح Sun Power من الشاشة الرئيسية',
    'إذا لم يفتح: الإعدادات → عام → VPN وإدارة الجهاز → اختر الملف الشخصي → ثقة'
  ],
  downloadAndroidNote: 'هذا التطبيق يُحمَّل من موقعنا وليس من Google Play. تحذير Play Protect طبيعي — اختر «التثبيت على أي حال».',
  downloadIosNote: 'يرجى استخدام Safari للتثبيت. المتصفحات الأخرى قد لا تثبّت الملف الشخصي بشكل صحيح.',
  downloadStarting: 'جارٍ تجهيز التحميل…',
  downloadStarted: 'بدأ التحميل. تحقق من المتصفح أو الإشعارات',
  downloadIosStarted: 'جارٍ فتح ملف التثبيت. اتبع التعليمات على الشاشة',
  downloadFail: 'فشل التحميل. حاول مرة أخرى',
  downloadUnavailable: 'حزمة التطبيق غير متوفرة. يرجى التواصل مع الدعم',
  legalLicense: 'الترخيص القانوني',
  businessReward: 'التشغيل والمكافآت',
  companyNews: 'أخبار الشركة',
  newsEmpty: 'لا توجد أخبار بعد',
  newsAttachment: 'عرض المرفق',
  loading: 'جارٍ التحميل…',
  attachmentLoadFail: 'فشل تحميل المرفق. حاول مرة أخرى.',
  vipLevelNotify: 'إشعار مستوى VIP',
  vipLevelChanged: 'تغير مستوى VIP لديك من {from} إلى {to}',
  gotIt: 'حسناً',
  loginNotice: 'إشعار',
  roulette: 'الروليت الروسي',
  prizes: 'الجوائز',
  lotteryRules: 'قواعد السحب',
  draw: 'سحب',
  lotteryTimes: 'فرص السحب',
  lotteryWin: 'لقد فزت',
  lotteryThanks: 'شكراً للمشاركة',
  lotteryThanksShort: 'شكراً',
  lotteryThanksTip: 'لا جائزة هذه المرة — حاول في السحب التالي',
  lotteryRewardTip: 'تمت إضافة {reward} إلى حسابك',
  lotteryTimesReward: 'حصلت على {n} فرصة/فرص إضافية',
  lotteryNoChance: 'لا توجد فرص سحب متبقية',
  catchSun: 'التقط ضوء الشمس',
  startGame: 'ابدأ',
  score: 'النقاط',
  timeLeft: 'الوقت المتبقي',
  gameOver: 'انتهت اللعبة',
  reward: 'المكافأة',
  timesLeft: 'المحاولات المتبقية',
  gameNoChance: 'لا محاولات متبقية اليوم',
  announcement: 'إعلان',
  noData: 'لا توجد بيانات',
  loginTip: 'سجّل الدخول بالبريد الإلكتروني',
  registerTip: 'أدخل UID للتسجيل',
  emailPlaceholder: 'أدخل بريدك الإلكتروني',
  passwordPlaceholder: 'أدخل كلمة المرور',
  confirmPassword: 'تأكيد كلمة المرور',
  confirmPasswordPlaceholder: 'أعد إدخال كلمة المرور',
  invitePlaceholder: 'أدخل UID',
  emailRequired: 'البريد الإلكتروني مطلوب',
  passwordRequired: 'كلمة المرور مطلوبة',
  passwordMin: '6 أحرف على الأقل',
  confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
  passwordMismatch: 'كلمتا المرور غير متطابقتين',
  inviteRequired: 'UID مطلوب',
  noAccount: 'ليس لديك حساب؟',
  hasAccount: 'لديك حساب بالفعل؟',
  registerSuccess: 'تم التسجيل بنجاح',
  show: 'إظهار',
  hide: 'إخفاء',
  back: 'رجوع',
  level: 'المستوى',
  checkinDays: 'أيام متتالية',
  checkinTip: 'سجّل الحضور {days} يوماً متتالية للحصول على فرصة سحب واحدة',
  doCheckin: 'سجّل الحضور الآن',
  alreadyCheckin: 'تم تسجيل الحضور اليوم',
  checkinSuccess: 'تم تسجيل الحضور بنجاح',
  checkinLottery: 'تم الحضور، +1 فرصة سحب',
  upgradeTip: 'يتطلب VIP1 استيفاء جميع الشروط أدناه',
  kycDone: 'اكتمل التحقق',
  firstRecharge: 'أول شحن',
  inviteKyc: 'دعوات مكتملة التحقق',
  inviteRecharge: 'شحن المدعوين',
  teamCount: 'دعوات مباشرة',
  teamL1: 'المستوى 1',
  teamL2: 'المستوى 2',
  teamL3: 'المستوى 3',
  teamAll: 'الكل',
  teamInviter: 'مدعو بواسطة',
  teamInviterNone: 'لا يوجد مُحيل (تسجيل بدون دعوة عضو)',
  teamDownline: 'مدعووّي',
  teamUpL1: 'المُحيل L1',
  teamUpL2: 'المُحيل L2',
  teamUpL3: 'المُحيل L3',
  teamUpRel1: 'من دعاك مباشرة',
  teamUpRel2: 'من دعا مُحيلك',
  teamUpRel3: 'المُحيل بمستويين أعلى',
  teamParentSelf: 'دعوة مباشرة (بواسطتك)',
  teamParentL1: 'مُحيل المستوى 1',
  teamParentL2: 'مُحيل المستوى 2',
  teamRefByL1: 'مدعو بواسطة L1 {email}',
  teamRefByL2: 'مدعو بواسطة L2 {email}',
  teamRefL1: 'تحت L1 {email}',
  logs: 'سجل الحساب',
  myOrders: 'طلباتي',
  dailyRebate: 'العائد اليومي',
  rebateToday: 'اليوم',
  rebateTotal: 'الإجمالي',
  rebateTip: 'العائد اليومي = رصيد kWh الحالي × النسبة: يُخصم kWh ويُضاف USD. شراء المنتجات يزيد kWh لزيادة العائد اليومي.',
  totalKwh: 'إجمالي kWh',
  pendingKwh: 'قيد الانتظار',
  releasedKwh: 'تم الإطلاق',
  orderStatus: {
    '0': 'نشط',
    '1': 'مكتمل',
    '2': 'مغلق'
  },
  exchangeTip: 'حوّل kWh المخزّن إلى رصيد USD',
  exchangeAvailable: 'المتاح',
  exchangeRate: 'السعر',
  exchangeFee: 'الرسوم',
  exchangeAmountKwh: 'المبلغ (kWh)',
  exchangeAll: 'الكل',
  exchangeReceive: 'ستستلم',
  exchangeExceed: 'يتجاوز kWh المتاح',
  exchangeNoKwh: 'لا يوجد kWh للتحويل',
  success: 'نجاح',
  playing: 'جارٍ اللعب',
  tapSun: 'المس ضوء الشمس الساقط لتسجيل النقاط',
  accountType: {
    USD: 'USD',
    KWH: 'kWh'
  },
  logType: {
    RECHARGE: 'شحن',
    WITHDRAW: 'سحب',
    WITHDRAW_REFUND: 'استرداد سحب',
    EXCHANGE: 'تحويل',
    GAME: 'مكافأة لعبة',
    LOTTERY: 'سحب',
    INVITE_KYC: 'مكافأة دعوة تحقق',
    BUY_PRODUCT: 'شراء منتج',
    REBATE_Ln: 'عمولة L{n}',
    REBATE_L1: 'عمولة المستوى 1',
    REBATE_L2: 'عمولة المستوى 2',
    REBATE_L3: 'عمولة المستوى 3',
    DAILY_REBATE: 'عائد يومي',
    MANAGE_REWARD: 'مكافأة الإدارة',
    ADMIN_ADJUST: 'تعديل إداري'
  }
}
